import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCalendar } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment-timezone';
import { Observable, Subject, Subscription } from 'rxjs';
import { ConfirmComponent } from 'src/app/dialog/confirm/confirm.component';
import { PaymentStatusDialogComponent } from 'src/app/dialog/payment-status-dialog/payment-status-dialog.component';
import { LocalStorage } from 'src/app/enums/local-storage-key.enum';
import { STATUS } from 'src/app/enums/status.enum';
import { SYSTEM } from 'src/app/enums/system.enum';
import { GroupAge } from 'src/app/models/group-age';
import { CommonResponse } from 'src/app/models/responses/common.response';
import { TicketModel } from 'src/app/models/ticket';
import { TicketType } from 'src/app/models/ticket-type';
import { ApiService } from 'src/app/services/api.service';
import { LoadingService } from 'src/app/services/loading.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { UtilityService } from 'src/app/services/utility.service';
import { fadeHeight, fadeOp, fadeOpInOut } from 'src/app/util/animations.util';
import { environment } from 'src/environments/environment';
import { LimitStatusDialogComponent } from '../../../dialog/limit-status-dialog/limit-status-dialog.component';
import { SnackbarMessageComponent } from '../../snackbar-message/snackbar-message.component';
import { TermsDialogComponent } from 'src/app/dialog/terms-dialog/terms-dialog.component';
import { UserModel } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';
import { DateAdapter } from '@angular/material/core';
import { MethodPaymentComponent } from 'src/app/dialog/method-payment/method-payment.component';
import { BANKS } from 'src/app/enums/bank.enum';
import { NavigationService } from 'src/app/services/navigation.service';
import { PAYMENT_STATUS } from 'src/app/enums/payment-status.enum';
import { filter, switchMap, takeUntil } from 'rxjs/operators';


// import 'moment/locale/km';

declare var turnstile: any;
declare global {
  interface Window {
    onTurnstileSuccess: (token: string) => void;
  }
}

enum STEP {
  TICKET_SELECTION = 0,
  NUMBER_OF_TICKET = 1,
  VISITOR_INFORMATION = 2,
  CONFIRM_PURCHASE = 3
}

@Component({
  selector: 'app-order-form',
  templateUrl: './order-form.component.html',
  styleUrls: ['./order-form.component.css'],
  animations: [
    fadeOpInOut,
    fadeOp,
    fadeHeight
  ]
})
export class OrderFormComponent implements OnInit, OnDestroy {
  dayControl = new FormControl();
  ticketTypes: TicketType[] = [];
  form!: FormGroup;
  stepOneFormGroup: FormGroup = this.formBuilder.group({
    num_day: ["", Validators.required],
    startDate: [""],
    day: this.formBuilder.array([], Validators.required),
    is_pickup: [false]
  });

  stepThreeFormGroup: FormGroup = this.formBuilder.group({
    date: [""],
    numOfTicket: ["", Validators.required],
    visitors: this.formBuilder.array([], Validators.required),
  });
  nationality = new FormControl("");
  visitorForm: FormArray = this.formBuilder.array([]);
  ticketForm: FormArray = this.formBuilder.array([]);
  hasTicket = new FormControl(false)

  isAgree: AbstractControl | null = new FormControl(false);
  ticketControl!: AbstractControl;
  validDate = new Date();
  countries: any[] = [];
  order: any;
  tickerOrderType: any;
  ticketGroup: any;
  enddate!: Date;
  groupsAge: GroupAge[] = [];
  DISPLAY_COLUMN: string[] = ["no", "start_date", "end_date", "national"];
  DISPLAY_DEFAULT_COLUMN: string[] = ["no", "image", "start_date", "end_date", "national"];
  tickets: TicketModel[] = [];
  filePath: string = environment.API_URL + "file/";
  isTicketLimit: boolean = false;
  MAX_TICKETS = 0;
  MIN_TICKETS = 1;
  paymentData: { [key: string]: any } = {};
  paymentForm: { [key: string]: any } = {};
  isChecking: boolean = false;
  allowDate!: string;
  isContinueToPayment: boolean = false;
  isSaving: boolean = false;
  isOver: { day: boolean, time: boolean } = { day: false, time: false };
  isCanRemoveTicket: boolean = false;
  isOneDayPass: boolean = true;

  isCantPurchaseToday: boolean = false;
  isCouldSave: boolean = false;
  today: Date = new Date();
  liveTime: String = '';
  intervalId: any;
  subscription!: Subscription;
  isKohker: boolean = false;
  isChongKhneas: boolean = false;
  isAngkor: boolean = false;
  system: string = "";
  limitTicket!: number;
  maxDate!: Date;
  selectedDates: moment.Moment[] = []
  numOfTicket: number = 1;
  currentDate: Date = new Date();
  ticketDefault: any;
  bank: any;
  banks: any;
  payment: { [key: string]: string } = {};
  paymentDetail: any;

  paymentInfo: any;
  actionUrl: string = '';
  paymentKey: string[] = [];
  isChangeDate: boolean = false;

  private transactionInterval: any;

  private _destroyed = new Subject<void>();


  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('calendar') calendar!: MatCalendar<Date>;
  currentUser!: UserModel;

  isEdit: boolean = false;
  isUpdateInform: boolean = false;

  isTicketTypeLoading: boolean = false;
  passtxt: string = 'MSG.ONEDAYPASS_ACCESS';
  panelOpenState = true;

  isConfirmpage = false;
  isPayment = true;
  isPaid: boolean = false;
  isInPayment: boolean = false;
  isUnPaid: boolean = false;
  selectedIndex: number = 0;


  formChanged = false;
  menuClicked = false;

  siteKey: string;
  cfToken!: string;
  orderToken!: string;
  paymentToken!: string;
  widgetId: string | null = null;
  actionPage: string = "purchase_order_form";

  private readonly defaultLang = 'en';

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private api: ApiService,
    private location: Location,
    private user: UserService,
    private router: Router,
    private snackbar: MatSnackBar,
    private loadingService: LoadingService,
    private utility: UtilityService,
    private dialog: MatDialog,
    private localStorage: LocalStorageService,
    private dateAdapter: DateAdapter<any>,
    private navService: NavigationService
  ) {
    this.siteKey = environment.RECAPTCHA_SITEKEY;
    this.isEdit = this.route.snapshot.data.isEdit || false;
    this.isUpdateInform = this.router.url.includes('edit');
    this.route.params
      .pipe(takeUntil(this._destroyed))
      .subscribe((params) => {
        this.system = params.system;
        this.getTicketType(this.system);
      });

    this.route.queryParams
      .pipe(takeUntil(this._destroyed))
      .subscribe(params => {

        const dynamicParam = params['ticket_type'];
        if (['1', '3', '7'].includes(dynamicParam) && this.system === SYSTEM.ANGKOR) {
          this.ticketDefault = dynamicParam;

        } else {
          this.ticketDefault = '1';
        }
      });
    this.localStorage.set(LocalStorage.ticket_type_param, this.ticketDefault);

    let locale = this.utility.getLang() || this.defaultLang;
    this.dateAdapter.setLocale(
      locale && typeof locale === 'string' ? locale : 'en'
    );
    this.init();
  }

  ngOnInit(): void {
    const utcCambodia = this.setDate_UTC_Cambodia(this.currentDate);
    this.validDate = new Date(utcCambodia);
    this.validDate.setHours(0, 0, 0, 0);
    this.today = new Date(this.validDate.getTime());
    this.dayControl.setValue(this.today);
    this.isAgree = this.formBuilder.control(false);
    this.form = this.formBuilder.group({
      isAgree: [false]
    });
    this.isAgree = this.form.get('isAgree');
    this.getDate();
    this.getBanks()
    setTimeout(() => {
      if (!this.isEdit) {
        this.setDates();
      }
    }, 100);
    if (!this.isEdit) {
      const savedTicketType = this.localStorage.get(LocalStorage.ticket_type_param);
      if (savedTicketType) {
        this.updateTicketType(Number(savedTicketType));
      }
    }

    this.stepOneFormGroup.get('num_day')!.valueChanges
      .pipe(takeUntil(this._destroyed))
      .subscribe((value: number) => {
        this.isCouldSave = true;
        this.ticketTypeChange(value);
      });

    this.subscription = this.stepOneFormGroup.get('day')!.valueChanges
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => {
        this.isChangeDate = true;
      });

    this.visitorForm.valueChanges
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => {
        this.isCouldSave = true;
      })
  }

  init(): void {
    this.loadingService._setLoading();
    if (this.isEdit) {
      this.route.queryParams
        .pipe(takeUntil(this._destroyed))
        .subscribe(query => {
          const id = query.id;
          this.isContinueToPayment = query.redirect == 'purchase';
          if (query.payment == '0') {
            this.dialog.open(PaymentStatusDialogComponent, {
              width: '450px',
              autoFocus: false,
              disableClose: true,
              role: 'alertdialog',
              data: {
                title: "TITLE.PAYMENT_STATUS",
                texts: ['MSG.PAYMENT_STATUS.UNPAY'],
                pay: false
              }
            })
          }
          this.api.getOrderById(id)
            .subscribe({
              next: response => {
                if (response.status != STATUS.SUCCESS)
                  return this.router.navigate(["/order"], { queryParams: { failed: id } });
                this.order = response.data.order;
                this.ticketGroup = this.order.tickets;
                this.tickets = this.ticketGroup.flatMap((t: any) => t.tickets);
                this.system = this.order.system;
                this.isKohker = this.system == SYSTEM.KOHKER;
                this.isChongKhneas = this.system == SYSTEM.CHONGKHNEAS;
                this.isAngkor = this.system == SYSTEM.ANGKOR;
                this.isPaid = this.order.status === PAYMENT_STATUS.PAID;
                this.isInPayment = this.order.status === PAYMENT_STATUS.IN_PAYMENT;
                this.isUnPaid = this.order.status === PAYMENT_STATUS.UNPAID;
                // this.limitTicket = this.isChongKhneas ? 45 : environment.limit_tickets;

                this.getNationalities();
                this.getTicketType(this.order.system);
                const ticket = this.order?.tickets[0].tickets[0].ticket.ticket_type;
                this.isOneDayPass = ticket.num_day == 1 ? true : false;
                this.isTicketLimit = this.tickets.length >= this.MAX_TICKETS;
                if (!this.isKohker && !this.isChongKhneas && (!this.isOneDayPass && this.isAngkor)) {
                  this.DISPLAY_COLUMN.splice(1, 0, 'image');
                }

                this.ticketGroup.forEach((ticket: any) => {
                  let ticketDate = moment.tz(ticket.start_date, 'Asia/Phnom_Penh').format('YYYY-MM-DD');
                  let setUTC_Date = this.utility.setDate_UTCCambodia(new Date(ticketDate));
                  this.selectMultipleDates(new Date(setUTC_Date), this.calendar);
                })

                const startDate = new Date(this.order.start_date);
                startDate.setHours(0, 0, 0, 0);
                this.stepOneFormGroup.patchValue({
                  num_day: ticket.num_day,
                  is_pickup: this.order.is_pickup,
                  startDate: startDate
                });

                this.stepOneFormGroup.get('day')!.markAsTouched();
                this.ticketForm.markAllAsTouched()
                this.setDates()
                this.enddate = ticket.expired_date;
                this.isCanRemoveTicket = this.visitorForm.length > 1;
                this.tickerOrderType = ticket;

                if (this.order.status === PAYMENT_STATUS.PAID) {
                  this.router.navigate(['/order', 'edit'], { queryParams: { id: this.order._id, redirect: 'purchase', payment: '1' } });
                  this._handlePaymentStatusDialogComponent();
                  this.localStorage.delete(LocalStorage.his_status);
                }
                if (!this.isPaid) this.localStorage.set(LocalStorage.his_status, this.order.status);

                if (!this.isPaid) {
                  this._handleCheckTransaction();
                  this.transactionInterval = setInterval(() => {
                    this._handleCheckTransaction();
                  }, 3000); // every 3 seconds
                }

                // validation
                this.subscription = this.stepOneFormGroup.get('num_day')!.valueChanges.subscribe(() => {
                  this.isCouldSave = true;
                });

                this.subscription = this.stepOneFormGroup.get('day')!.valueChanges.subscribe(() => {
                  this.isCouldSave = true;
                });

                this.subscription.add(
                  this.ticketForm.valueChanges.subscribe(() => {
                    this.isCouldSave = true;
                  })
                );

                this.visitorForm.controls?.forEach((visitorControl) => {
                  const visitorGroup = visitorControl.get('visitors') as FormArray;
                  if (visitorGroup) {
                    this.subscription = visitorGroup.valueChanges.subscribe(() => {
                      this.isCouldSave = true;
                    });
                  }
                });

              },
              error: () => {
                return this.router.navigate(["/order"], { queryParams: { failed: id } });
              }
            })
        })
      return;
    }
    this.getNationalities();
    this.isKohker = this.system == SYSTEM.KOHKER;
    this.isChongKhneas = this.system == SYSTEM.CHONGKHNEAS;
    this.isAngkor = this.system == SYSTEM.ANGKOR;
    this.MAX_TICKETS = this.ticketTypes[0]?.limited_per_day;

    if (!(this.isKohker || this.isChongKhneas || this.isOneDayPass)) {
      this.DISPLAY_COLUMN.splice(1, 0, 'image');
    }

    this.stepOneFormGroup.valueChanges.subscribe(() => {
      this.isCouldSave = true;
    });

    this.subscription = this.visitorForm.valueChanges.subscribe(() => {
      this.isCouldSave = true;
    })
  }

  renderTurnstile(actionName: string): Promise<string> {
    return new Promise((resolve, reject) => {

      if (!turnstile) {
        reject('Turnstile not loaded');
        return;
      }

      const widget = document.getElementById('turnstile-widget');
      if (!widget) {
        reject('Turnstile widget not found');
        return;
      }

      widget.innerHTML = '';

      const widgetId = turnstile.render(widget, {
        sitekey: this.siteKey,
        size: 'invisible',
        action: actionName,

        callback: (token: string) => {
          if (actionName === 'order_form_web') {
            this.orderToken = token;
          }

          if (actionName === 'payment_web') {
            this.paymentToken = token;
          }

          resolve(token);
        },

        'error-callback': (err: any) => {
          turnstile.reset(widgetId);
          reject(err);
        },

        'expired-callback': () => {
          turnstile.reset(widgetId);
          reject('Token expired');
        }
      });

      turnstile.execute(widgetId);
    });
  }

  handleLostConnectionDialog(): void {
    this.dialog.open(LimitStatusDialogComponent, {
      width: '450px',
      autoFocus: false,
      disableClose: true,
      data: {
        title: 'TITLE.CONNECTION',
        messages: 'MSG.CONNECTION_LOST',
        isConnectionLost: true
      },
    });
  }

  getBanks() {
    this.api.getBanks()
      .subscribe({
        next: (res) => {
          if (res?.status === STATUS.SUCCESS) {
            this.banks = res?.data ?? [];
          }
        },
        error: (err) => {
          console.log('Error fetching banks', err);
        }
      })
  }

  private updateTicketType(value: any): void {
    if (this.ticketDefault === value) {
      return;
    }

    this.ticketDefault = value;
    this.localStorage.set(LocalStorage.ticket_type_param, value);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { ticket_type: value },
    });
    this.isOneDayPass = value === 1;
    if (this.isOneDayPass) {
      this.DISPLAY_COLUMN = ["no", "start_date", "end_date", "national"];
    }
  }

  navigateToOrder(): void {
    this.router.navigateByUrl('/order');
  }

  hasUnsavedChanges(): boolean {
    return this.navService.consumeMenuClicked().clicked;
  }

  onChange(event: any) {
    this.isTicketLimit = event > this.MAX_TICKETS;
    if (event > this.MAX_TICKETS) return this.openMessageSnackbar('MSG.TICKET_LIMITED', 3000);
  }

  getOvertime(time: { hours: number, minutes: number }): { day: boolean, time: boolean } {
    var day = time.hours >= 16 ? time.hours == 16 ? time.minutes > 29 : true : false
    return {
      day,
      time: this.today.getTime() >= this.dayControl.value.getTime() && day,
    }
  }

  getNationalities(): void {
    this.api.getNationalities({ system: this.system })
      .subscribe(response => {
        this.countries = response.data.sort((a: any, b: any) => a.nationality.localeCompare(b.nationality));
      });
  }

  getDate() {
    var date = moment()
    this.allowDate = date.subtract(12, "year").format('DD-MMM-YYYY');
  }

  getTicketType(system: string): void {
    this.loadingService._setLoading();
    this.api.getTicketType({ system, channel: 'web' })
      .subscribe(response => {
        if (response.status != STATUS.SUCCESS) {
          return;
        }
        this.ticketTypes = response.data.ticket_types;
        this.MAX_TICKETS = this.ticketTypes[0]?.limited_per_day;
        this.loadingService._clearLoading();
        if (this.isEdit) return;
        this.stepOneFormGroup.patchValue({
          num_day: value ? value.num_day : this.ticketDefault

        });
      })
    const queryValue = this.route.snapshot.queryParams.tt;
    const value = this.ticketTypes.find(type => type.num_day == Number(queryValue));
  }

  setDates() {
    const now = moment.tz('Asia/Phnom_Penh');
    const hour = now.hour();
    const minute = now.minute();
    this.liveTime = this.setLiveDateFormat(now).toString();

    // Today time is after 4:30 PM
    if (hour > 16 || (hour == 16 && minute > 29)) {
      // If after 4:30 PM, set validDate to tomorrow and set 'overday' err
      this.validDate.setDate(this.today.getDate() + 1);
      this.dayControl.setErrors({ overday: true });
    } else {
      this.dayControl.setErrors(null);
    }
    this.maxDate = moment(this.validDate).add(1, 'month').toDate();
  }

  selectMultipleDates(event: Date, calendar: any): void {
    const selected = moment(event).format('YYYY-MM-DD');

    // check if date already exists
    const exists = this.dayFormArray.value.includes(selected);

    if (!exists) {
      if (this.dayFormArray.value.length > 0) {
        this.dayFormArray.removeAt(0);
      }
      if (this.dayFormArray.value.length == 0) this.addDay(selected);
      calendar.updateTodaysDate();
      this.allTicket();
      this.allVisitor();
    }
  }


  allTicket(): void {
    const newDates = this.dayFormArray.controls.map(control => control.value);
    const existingControls = this.ticketForm.controls.reduce((acc, control, index) => {
      const date = (control as FormGroup).get('date')?.value;
      if (date) {
        acc[date] = index;
      }
      return acc;
    }, {} as { [key: string]: number });

    // Remove controls that are no longer needed
    for (let i = this.ticketForm.length - 1; i >= 0; i--) {
      const control = this.ticketForm.at(i);
      const date = (control as FormGroup).get('date')?.value;
      if (date && !newDates.includes(date)) {
        this.ticketForm.removeAt(i);
      }
    }
    newDates.forEach(date => {
      if (!existingControls.hasOwnProperty(date)) {
        let matchedTicket;
        if (this.isEdit) {
          this.ticketGroup.forEach((ticket: any) => {
            let changeDate = this.isCouldSave ? date : ticket.start_date;
            let ticketDate = moment.tz(changeDate, 'Asia/Phnom_Penh').format('YYYY-MM-DD');
            let setUTC_Date = this.utility.setDate_UTCCambodia(new Date(ticketDate));
            const selectDate = moment(setUTC_Date).format('YYYY-MM-DD');

            if (selectDate == date) {
              ticket.start_date = ticketDate;
              matchedTicket = ticket;
            }
          })
        }

        const numTickets = matchedTicket ? (matchedTicket?.num_ticket ? matchedTicket?.num_ticket : this.MIN_TICKETS) : this.MIN_TICKETS

        const ticket = this.createTicketForm(date, numTickets);
        const visitor = this.defaultVisitorInfo(date, numTickets);

        this.visitorForm.push(visitor);
        this.ticketForm.push(ticket);
      }
    });
    const sortedTicketControls = this.ticketForm.controls.sort((a, b) => {
      const dateA = new Date((a as FormGroup).get('date')?.value).getTime();
      const dateB = new Date((b as FormGroup).get('date')?.value).getTime();
      return dateA - dateB;
    });

    this.ticketForm.setValue(sortedTicketControls.map(control => control.value));

  }

  incrementTicket(index: number, date: any): void {
    const ticketGroup = this.ticketForm.at(index) as FormGroup;
    const currentNum = ticketGroup.get('numOfTicket')?.value;

    if (currentNum < this.MAX_TICKETS) {
      ticketGroup.get('numOfTicket')?.setValue(currentNum + 1);
      this.isCouldSave = true;
      this.isTicketLimit = false;
    } else {
      this.isTicketLimit = true;
    }
    const numTicket = ticketGroup.value.numOfTicket;
    this.onAddVisitor(date, numTicket);

  }

  decrementTicket(index: number): void {
    const ticketGroup = this.ticketForm.at(index) as FormGroup;
    const currentNum = ticketGroup.get('numOfTicket')?.value;

    if (currentNum > this.MIN_TICKETS) {
      ticketGroup.get('numOfTicket')?.setValue(currentNum - 1);
    }

    let numTicket = ticketGroup.value.numOfTicket;
    this.onRemoveVisitor(index, numTicket);

  }

  private createTicketForm(date: string, numOfTicket: number): FormGroup {
    return this.formBuilder.group({
      date: [date, Validators.required],
      numOfTicket: [numOfTicket, Validators.required],
    });
  }

  isSelected = (event: any): string | null => {
    let selected = moment(event).format('YYYY-MM-DD');
    let setUTC_Date = this.utility.setDate_UTCCambodia(new Date(selected));

    let selectedDate = moment(setUTC_Date).format('YYYY-MM-DD');
    const isDateSelected = this.dayFormArray.controls.some((control) => control.value === selectedDate);

    const todayAt430 = moment(this.validDate).set({ hour: 16, minute: 30, second: 0, millisecond: 0 });
    const ticketDate = moment(selectedDate).endOf('day');

    if (ticketDate.isBefore(todayAt430)) {
      return null;
    }

    return isDateSelected ? "selected" : null;
  };

  addDay(date: string): void {
    // Set today at 4:30 PM in Cambodia timezone for comparison
    const todayAt430PM = moment(this.validDate).tz('Asia/Phnom_Penh').set({ hour: 16, minute: 30, second: 0, millisecond: 0 });
    const setUTC_Date = this.utility.setDate_UTCCambodia(new Date(date));
    const selectedDate = moment(setUTC_Date).format('YYYY-MM-DD');
    let ticketDate = moment(selectedDate).endOf('day');
    if (ticketDate.isBefore(todayAt430PM)) return;

    const dateControl = this.formBuilder.control(date, Validators.required);
    this.dayFormArray.push(dateControl);
    this.defaultVisitorInfo(date, this.MIN_TICKETS);
    // if (!this.isEdit) this.ticketGroup = this.visitorForm.value[0]?.visitors.map((ticket) => ticket)

  }

  removeDay(index: number, date: string): void {
    const indexV = this.visitorForm.controls.findIndex(control => control.value.date === date);
    this.dayFormArray.removeAt(index);
    this.visitorForm.removeAt(indexV) as any;
  }

  ticketTypeChange(value: any): void {
    this.isOneDayPass = value == 1;
    if (this.isOneDayPass) {
      this.DISPLAY_COLUMN = ["no", "start_date", "end_date", "national"];
    }
    if (!this.isUpdateInform) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { ticket_type: value },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });

      if (this.ticketDefault) this.localStorage.set(LocalStorage.ticket_type_param, value);
    }

    switch (value) {
      case 3:
        this.passtxt = "MSG.TREEDAYSPASS_ACCESS";
        break;

      case 7:
        this.passtxt = "MSG.SEVENDAYSPASS_ACCESS";
        break;

      case 1:
        this.passtxt = "MSG.ONEDAYPASS_ACCESS";
        break;

      default:
        break;
    }

    // Check validation when ticket type
    this.visitorForm.controls?.forEach((visitorControl) => {
      const visitorGroup = visitorControl.get('visitors') as FormArray;
      visitorGroup.controls.forEach((visControl: FormGroup) => {
        visControl.setControl('date', new FormControl(visControl.value.date || '', Validators.required));
        visControl.setControl('photo', new FormControl(visControl.value.photo || '', this.isOneDayPass ? null : Validators.required));
        visControl.setControl('photoURL', new FormControl(''));
        visControl.setControl('nationality', new FormControl(visControl.value.nationality || '', Validators.required));
        visControl.updateValueAndValidity();
      });
    });
  }

  allVisitor() {
    if (this.visitorForm.value.length > 1) this.visitorForm.removeAt(0);
    const sortedTicketControls = this.visitorForm.controls.sort((a, b) => {
      const dateA = new Date((a as FormGroup).get('date')?.value).getTime();
      const dateB = new Date((b as FormGroup).get('date')?.value).getTime();
      return dateA - dateB;
    });
    this.visitorForm.setValue(sortedTicketControls.map(control => control.value));
  }

  defaultVisitorInfo(date: any, num_ticket: number): FormGroup {
    const ticketByDate = this.ticketGroup?.find((ticket: any) => {
      const setUTC_Date = this.utility.setDate_UTCCambodia(new Date(ticket.start_date));
      const selectedDate = moment(setUTC_Date).format('YYYY-MM-DD');
      return moment(selectedDate).format('YYYY-MM-DD') == date;
    });
    const visitorsArray = this.formBuilder.array([]);

    const createVisitorFormGroup = (ticket: any = {}) => this.formBuilder.group({
      date: [ticket.date || date],
      photo: [ticket.photo || '', this.isPhotoRequired() ? Validators.required : null],
      photoURL: [ticket.photoURL || ''],
      nationality: [ticket.nationality || '', Validators.required]
    });

    if (ticketByDate?.tickets?.length) {
      ticketByDate.tickets.forEach((ticket: any) => {
        visitorsArray.push(createVisitorFormGroup(ticket.ticket));
      });
    } else {
      Array.from({ length: num_ticket }).forEach(() => {
        visitorsArray.push(createVisitorFormGroup());
      });
    }

    this.stepThreeFormGroup = this.formBuilder.group({
      date: [date],
      numOfTicket: [num_ticket],
      visitors: visitorsArray
    });
    return this.stepThreeFormGroup;
  }

  updateVisitorInfo(date: any) {
    // Check validation when ticket type
    this.visitorForm.controls?.forEach((visitorControl) => {
      const visitorGroup = visitorControl.get('visitors') as FormArray;
      visitorGroup.controls.forEach((visControl: FormGroup) => {
        visControl.setControl('date', new FormControl(date || '', Validators.required));
        visControl.setControl('photo', new FormControl(visControl.value.photo || '', this.isOneDayPass ? null : Validators.required));
        visControl.setControl('photoURL', new FormControl(''));
        visControl.setControl('nationality', new FormControl(visControl.value.nationality || '', Validators.required));
        visControl.updateValueAndValidity();
      });
    });
  }


  onAddVisitor(date: any, num_ticket: number) {
    const selectDate = moment(date).format('YYYY-MM-DD');
    const indexV = this.visitorForm.controls.findIndex(visitor => moment(visitor.value.date).format('YYYY-MM-DD') == selectDate);
    const newVisitorGroup = this.formBuilder.group({
      date: [selectDate],
      photo: ['', this.isPhotoRequired() ? Validators.required : null],
      photoURL: '',
      nationality: ['', Validators.required]
    });

    this.visitorForm.controls[indexV].patchValue({
      numOfTicket: [num_ticket],
    })
    const visitorsArray = this.visitorForm.at(indexV).get('visitors') as FormArray;
    visitorsArray.push(newVisitorGroup);
  }

  onRemoveVisitor(formIndex: number, num_ticket: number): void {
    const visitorsArray = this.visitorForm.at(formIndex).get('visitors') as FormArray;
    if (visitorsArray.length > 0) {
      visitorsArray.removeAt(visitorsArray.length - 1);
      this.visitorForm.at(formIndex).patchValue({
        numOfTicket: num_ticket
      });
    }
  }

  clearDates() {
    this.selectedDates = [];
    this.ticketForm = this.formBuilder.array([]);
    this.visitorForm = this.formBuilder.array([])

    this.dayFormArray.clear();
    this.calendar.updateTodaysDate();
    this.stepOneFormGroup.controls['day'].reset();
    this.stepThreeFormGroup.reset();
  }

  checkDay(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (+input.value < 1) {
      this.stepOneFormGroup.patchValue({
        num_day: 1 // match your form control name
      });
    }
  }

  async handleStepChange(e: StepperSelectionEvent): Promise<void> {
    this.selectedIndex = e.selectedIndex;
    // this.isPayment = true;
    if (!this.isCouldSave) {
      return;
    }
    switch (e.selectedIndex) {
      case 2:
        this.hasTicket.setValue(true);
        break;

      case 3:
        this.save();
        break;
    }
  }

  getTables(): void {
    if (!this.isOneDayPass) {
      if (!this.DISPLAY_COLUMN.includes('image')) {
        this.DISPLAY_COLUMN.splice(1, 0, 'image');
      }
    } else {
      this.DISPLAY_COLUMN = ["no", "start_date", "end_date", "national"];
    }
  }

  goBack(stepper: MatStepper): void {
    if (stepper.selectedIndex > 0) {
      stepper.previous();
      return;
    }
    if (!this.isCouldSave) {
      this.location.back();
      return;
    }
    this.dialog.open<ConfirmComponent>(ConfirmComponent, {
      data: {
        translate: {
          title: 'TITLE.DATA_NOT_SAVE',
          descriptions: ['MSG.SAVE_DATA'],
          postive: 'LABEL.SAVE',
          negative: "LABEL.NO",
          isDelete: false
        }
      },
      width: '450px',
      role: 'dialog',
      disableClose: true
    })
      .afterClosed()
      .subscribe(response => {
        if (response) {
          this.save()
            .then(() => {
              this.location.back();
            });
          return;
        }
        this.location.back();
      })
  }

  onCancel() {
    this.navService.setMenuClicked(false);
    const shouldConfirm =
      (this.visitorForm.valid && this.selectedIndex === 3) ||
      (this.isCouldSave && this.visitorForm.valid) || (this.isEdit && this.isCouldSave);

    const isVisitorFormDirty = this.visitorForm.invalid;

    if (this.visitorForm.value.length > 0 && shouldConfirm) {
      this.openConfirmDialog(isVisitorFormDirty);
    } else {
      this.navigateBack();
    }
  }

  private navigateBack(): void {
    this.router.navigate(['/purchases']);
  }

  openConfirmDialog(isVisitorFormDirty: boolean): void {
    const translate = isVisitorFormDirty
      ? {
        title: 'TITLE.CHANGE_DATE',
        descriptions: ['MSG.CHANGE_DATE'],
        close: 'LABEL.CHANGE_DATE',
        postive: 'TITLE.CHANGE_DATE',
        negative: 'LABEL.CANCEL',
        isDelete: false,
        isChangeDate: true
      } :
      {
        title: 'TITLE.CANCEL_ORDER',
        descriptions: ['MSG.CANCEL_ORDER_CONFIRM'],
        close: 'LABEL.CLOSE',
        postive: 'LABEL.SAVE',
        negative: "LABEL.NO",
        isDelete: false
      }

    this.dialog.open<ConfirmComponent>(ConfirmComponent, {
      data: {
        translate: { ...translate }
      },
      width: '450px',
      role: 'dialog',
      disableClose: true
    })
      .afterClosed()
      .subscribe(response => {
        if (this.dayFormArray.invalid && response?.status) {
          this.openMessageSnackbar('MSG.DATE_INVALID', 3000);
          return;
        };
        if (response?.status) {
          if (response.data.translate?.isChangeDate) {
            this.stepper.selectedIndex = STEP.TICKET_SELECTION;
          } else {
            this.save().then(() => {
              this.router.navigate(['/purchases']);
            });
          }
          return;
        } else if (response?.status == false) {
          this.router.navigate(['/purchases']);
          return;
        }
      })
  }

  private save(): Promise<void> {
    return new Promise(async (onSave, onError) => {
      const order = this.stepOneFormGroup.value;
      const typeId = this.ticketTypes.find((ticket: any) => ticket.num_day == order.num_day)?._id;
      const tickets: any[] = [];
      this.visitorForm.controls.map((v) => {
        tickets.push(...v.value.visitors);
      });
      const isAgree = this.isAgree;

      if (!isAgree) return;
      const payload: any = {
        system: this.system,
        channel: 'web',
        email: this.self.email || '',
        is_pickup: order.is_pickup,
        tickets: tickets.map(ticket => ({
          nationality: ticket.nationality,
          photo: order.num_day == 1 ? undefined : ticket.photo,
          ticket_type_id: typeId,
          start_date: ticket.date,
          num_ticket: ticket.numOfTicket || this.MIN_TICKETS
        }))
      }
      this.tickerOrderType = this.ticketTypes.find(ticket => ticket.num_day == order.num_day);
      this.isSaving = true;
      this.loadingService._setLoading();

      // WORK IF EDIT
      if (this.isEdit) {
        this.api.updateOrderByID(payload, this.order._id)
          .subscribe({
            next: response => {
              this.handleSaveResponseSuccess(response, onSave);
            },
            error: () => {
              this.openMessageSnackbar('MSG.SAVE_FAILED', 3000);
              onError();
            },
            complete: () => {
              this.isSaving = false;
              this.loadingService._clearLoading();
            }
          })
        return;
      }
      // WORK IF NEW PURCHASE
      try {
        await this.renderTurnstile('order_form_web');
        if (!this.orderToken) {
          await this.renderTurnstile('order_form_web');
          return this.save();
        }
        payload.recaptchaToken = this.orderToken;
        const response = await this.api.createOrderV3(payload).toPromise();

        if ([STATUS.reCAPTCHA_EXPIRED, STATUS.INVALID_TOKEN, STATUS.MISSING_reCAPTCHA, STATUS.SERVER_ERROR].includes(response.code)) {
          await this.renderTurnstile('order_form_web');
          return this.save();
        }

        this.handleSaveResponseSuccess(response, onSave);
      } catch (error) {
        this.stepper.selectedIndex = STEP.VISITOR_INFORMATION;
        this.openMessageSnackbar("MSG.SOMETHINK_WENT_WRONG", 3000);
        // console.error('Error during save operation:', error);
      } finally {
        this.isSaving = false;
        this.loadingService._clearLoading();
      }

    })
  }

  private handleSaveResponseSuccess(response: CommonResponse, success?: () => void): void {
    var order_id: string;

    switch (response.status) {
      case STATUS.ERROR_CLIENT:
        let errorTickets = response?.errors?.find((error: any) => /tickets/.test(error.param));
        let msg = response?.errors[0]?.msg;
        let data = response?.errors[0]?.data;

        if (!errorTickets) {
          this.openMessageSnackbar(msg, 3000);
          this.stepper.selectedIndex = STEP.NUMBER_OF_TICKET;
          this.stepOneFormGroup.markAllAsTouched();
        }
        else if (data == null) {
          this.messageError(this.stepper.selectedIndex);
        }
        break;
      case STATUS.ERROR_OTHER:
        this.dialog.open(LimitStatusDialogComponent, {
          width: '450px',
          autoFocus: false,
          disableClose: true,
          data: {
            title: 'TITLE.SUBMIT_LIMIT',
            messages: response.message
          },
        });
        this.stepper.selectedIndex = STEP.TICKET_SELECTION;
        break;
      case STATUS.ERROR_SERVER:
        this.messageError(this.stepper.selectedIndex);
        break;

      default:
        // SUCCESS HERE PLEASE DO SOMETHINK
        order_id = this.isEdit ? this.order._id : response.data.order._id
        if (success) {
          success()
        }
        this.isCouldSave = false;
        this.getOrderByID(order_id);
        break;
    }
  }

  messageError(selectIndex: number) {
    switch (selectIndex) {
      case 0:
        this.hasTicket.setValue(true);
        this.stepper.selectedIndex = STEP.NUMBER_OF_TICKET;
        this.stepper.selectedIndex = STEP.VISITOR_INFORMATION;
        this.stepThreeValidatorMessage();
        break;
      case 1:
        this.stepper.selectedIndex = STEP.VISITOR_INFORMATION;
        this.stepThreeValidatorMessage();
        break;
      case 2:
        this.stepThreeValidatorMessage();
        break;
      case 3:
        this.stepThreeValidatorMessage();
        break;
      default:
        this.openMessageSnackbar('MSG.SAVE_FAILED', 3000);
        break;
    }
  }

  getOrderByID(id: string): void {
    this.api.getOrderById(id)
      .subscribe({
        next: response => {
          if (response.status != STATUS.SUCCESS) {
            this.openMessageSnackbar("MSG.SOMETHINK_WENT_WRONG", 3000);
            return;
          }
          // this.getPaymentData();
          this.isEdit = true;
          this.order = response.data.order;
          this.ticketGroup = this.order.tickets;
          this.tickets = this.order.tickets.flatMap((t: any) => t.tickets);
          const ticket = this.order?.tickets[0].tickets[0].ticket.ticket_type;
          this.enddate = this.tickets[0]?.expired_date ?? new Date();
          this.isOneDayPass = ticket.num_day == 1 ? true : false;
        },
        error: () => {
          this.openMessageSnackbar("MSG.SOMETHINK_WENT_WRONG", 3000);
        }
      });
  }

  _handleCheckTransaction(): void {
    if (!this.order?._id) {
      console.warn('Order ID missing, cannot check transaction.');
      return;
    }

    this.api.checkTransaction({ order_id: this.order._id, is_local: 1 })
      .subscribe({
        next: (response) => {
          if (response.status != STATUS.SUCCESS) {
            // console.warn('Transaction check returned non-success status', response);
            return;
          }

          if (!response.data || !response.data.status) {
            // console.warn('Invalid payment response', response);
            return;
          }

          const status = response.data.status;

          if (status === PAYMENT_STATUS.SUCCESS || status === PAYMENT_STATUS.FAILED) {
            const isSuccess = status === PAYMENT_STATUS.SUCCESS;

            if (isSuccess) {
              this.router.navigate(['/order', 'edit'], { queryParams: { id: this.order._id, redirect: 'purchase', payment: '1' } });
              this.getOrderByID(this.order._id);
              this._handlePaymentStatusDialogComponent();
            }

            this.clearTransactionInterval();
          }
        },
        error: (err) => {
          if (err.status === 0) {
            console.error('Network or CORS error when checking transaction', err);
          } else {
            console.error(`HTTP error ${err.status}: ${err.message}`, err);
          }
        }
      });
  }

  clearTransactionInterval() {
    if (this.transactionInterval) {
      clearInterval(this.transactionInterval);
      this.transactionInterval = null;
    }
  }

  // _handleCheckTransaction(): void {
  //   this.api.checkTransaction({ order_id: this.order._id, is_local: 1 })
  //     .subscribe(response => {
  //       if (response.status != STATUS.SUCCESS) {
  //         return;
  //       }
  //       if (!response.data || !response.data.status) {
  //         console.warn('Invalid payment response', response);
  //         return;
  //       }
  //       if (response.data.status == PAYMENT_STATUS.SUCCESS || response.data.status == PAYMENT_STATUS.FAILED) {
  //         const isSuccess = response.data.status == PAYMENT_STATUS.SUCCESS;
  //         if (isSuccess) {
  //           this.router.navigate(['/order', 'edit'], { queryParams: { id: this.order._id, redirect: 'purchase', payment: '1' } });
  //           this.getOrderByID(this.order._id);

  //           // this._handlePaymentStatusDialogComponent();
  //         }

  //         // ✅ stop polling once paid
  //         if (this.transactionInterval) {
  //           clearInterval(this.transactionInterval);
  //           this.transactionInterval = null;
  //         }
  //       }
  //     });
  // }

  _handlePaymentStatusDialogComponent(): void {
    this.dialog.open(PaymentStatusDialogComponent, {
      width: '450px',
      autoFocus: false,
      disableClose: true,
      role: 'alertdialog',
      data: {
        title: "TITLE.PAYMENT_STATUS",
        texts: ['MSG.PAYMENT_STATUS.PAY'],
        pay: true
      }
    }).afterClosed()
      .subscribe(() => {
        this.router.navigate(['/order/view'], {
          queryParams: { id: this.order._id }
        });
      });
    return;
  }


  openMessageSnackbar(message: string, duration: number): void {
    this.snackbar.openFromComponent(SnackbarMessageComponent, {
      data: {
        message,
        center: true,
      },
      duration,
      panelClass: 'bg-warn'
    });
  }

  async onSetupPayment(order_id: string, stepper: MatStepper): Promise<void> {
    if (this.stepOneFormGroup.invalid) {
      this.openMessageSnackbar('MSG.DATA_INVALID', 3000);
      stepper.selectedIndex = 0;
      return;
    }
    else if (this.ticketForm.invalid) {
      this.openMessageSnackbar('MSG.DATA_INVALID', 3000);
      stepper.selectedIndex = 1;
      return;
    }

    this.loadingService._setLoading();
    await this.renderTurnstile('payment_web')
    this.isPayment = this.isAgree ? true : false;
    this.api.submitOrder(order_id, this.system)
      .subscribe({
        next: response => {
          if (response.status == STATUS.ERROR_OTHER) {
            this.dialog.open(LimitStatusDialogComponent, {
              width: '450px',
              autoFocus: false,
              disableClose: true,
              data: {
                title: 'TITLE.SUBMIT_LIMIT',
                messages: 'MSG.SUBMIT_LIMIT'
              },
            });
            return;
          } else if (response.status != STATUS.SUCCESS) {
            this.openMessageSnackbar('MSG.SUBMIT_FAILED', 3000);
            return;
          }

          this.isChecking = false;
          this.localStorage.set(LocalStorage.PAY_ORDER, order_id);
          this.localStorage.set(LocalStorage.PAYMENT_IN, 'form');
          this.loadingService._setLoading();
          this.methodPayment()
        },
        error: () => {
          this.openMessageSnackbar('MSG.SOMETHINK_WENT_WRONG', 3000);
        },
        complete: () => {
          this.loadingService._clearLoading();
        }
      })
  }

  methodPayment(): void {
    this.loadingService._setLoading();
    this.dialog.open(MethodPaymentComponent, {
      width: '100%',
      maxWidth: '550px',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      autoFocus: false,
      data: {
        _id: this.order._id,
        banks: this.banks
      }
    }).afterClosed()
      .pipe(
        filter((result: any) => !!result?.data),
        switchMap((result: any) => {
          this.bank = result.data;
          return this.getPaymentData();
        }
        )

      )
      .subscribe(result => {
        setTimeout(() => {
          switch (this.paymentDetail?.bank) {
            case BANKS.ABA:
              try {
                this.loadingService._clearLoading();
                document.forms['aba_merchant_request']?.submit();
              } catch (err) {
                console.error('ABA checkout error:', err);
              }
              break;

            case BANKS.ACLEDA:
              try {
                this.loadingService._clearLoading();
                document.forms['_xpayTestForm']?.submit();

              } catch (err) {
                console.error('ACLEDA checkout error:', err);
              }
              break;

            default:
              console.warn('Unsupported bank:', this.bank.name);
          }
        }, 500);
        this.location.replaceState('/order/edit', `id=${this.order._id}&redirect=purchase`);
        this.localStorage.set(LocalStorage.go_back_url, 'preview');
      });
  }

  getPaymentData(): Observable<void> {
    const payload: any = {
      client_type: 'web',
      order_id: this.order._id,
      payment_option: this.bank?.payment_option,
      recaptchaToken: this.paymentToken
    };

    if (!((this.bank?.code === BANKS.ABA || this.bank?.code === 'other') && this.bank?.payment_option === BANKS.CARD)) {
      payload.bank_name = this.bank?.code;
    }

    return new Observable(subscriber => {
      this.loadingService._setLoading();
      this.api.paymentDataV3(payload)
        .subscribe(async response => {
          if (response.status == STATUS.ERROR_ORDER_EXIST) {
            this.dialog.open(PaymentStatusDialogComponent, {
              width: '450px',
              autoFocus: false,
              disableClose: true,
              role: 'alertdialog',
              data: {
                title: "TITLE.PAYMENT_STATUS",
                texts: ['MSG.PAYMENT_STATUS.PAY'],
                pay: true,
              }
            }).afterClosed()
              .subscribe(() => {
                // set redirect to order view
                this.router.navigate(['/order/view'], {
                  queryParams: { id: this.order._id }
                });
              });
            return;
          }
          else if (response.status === 0 && ([STATUS.reCAPTCHA_EXPIRED, STATUS.INVALID_TOKEN, STATUS.MISSING_reCAPTCHA, STATUS.SERVER_ERROR].includes(response.code))) {
            await this.renderTurnstile('payment_web');
          }
          else if (response.status === STATUS.ERROR_SERVER) {
            this.openMessageSnackbar("MSG.SOMETHINK_WENT_WRONG", 3000);
            return;

          }
          else if (response.status != STATUS.SUCCESS) {
            this.openMessageSnackbar(response.errors?.[0]?.msg, 3000);
            subscriber.error(response);
            subscriber.complete();
            return;
          }
          // SAVE ORDER ID FOR REDIRECT
          this.paymentDetail = response.data;
          this.payment = response.data?.payment;
          this.paymentInfo = Object.assign({}, this.payment);
          this.actionUrl = this.payment.actionUrl;
          this.paymentKey = Object.keys(this.paymentInfo);
          this.localStorage.set(LocalStorage.payment_data, JSON.stringify(this.paymentDetail));

          if (this.paymentKey.indexOf('paymentCard') >= 0) {
            this.paymentKey.splice(this.paymentKey.indexOf('paymentCard'), 1);
          }

          if (this.paymentKey.indexOf('operationType') >= 0) {
            this.paymentKey.splice(this.paymentKey.indexOf('operationType'), 1);
          }

          if (this.paymentKey.indexOf('actionUrl') >= 0) {
            this.paymentKey.splice(this.paymentKey.indexOf('actionUrl'), 1);
          }

          subscriber.next();
          subscriber.complete();
        });
    })
  }

  onACLEDAPay() {
    this.dialog.open(MethodPaymentComponent, {
      width: '100%',
      maxWidth: '410px',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      autoFocus: false,
      data: {
        _id: this.order._id,
        payment: this.payment,
        isACPayment: true
      }
    }).afterClosed()
      .subscribe(() => { });
  }

  isPhotoRequired(): boolean {
    // return !(this.isKohker || this.isChongKhneas || (this.isOneDayPass && this.isAngkor) );
    return !this.isOneDayPass && this.isAngkor;
  }

  get dayFormArray(): FormArray {
    return this.stepOneFormGroup.get('day') as FormArray;
  }

  get quantity(): number[] {
    const numTickets = this.stepOneFormGroup.get('num_tickets')?.value;
    return numTickets;
  }

  get totalTicket() {
    const numTickets = this.ticketForm.value;
    let total = 0;
    numTickets.forEach((ticket: any) => {
      total += ticket.numOfTicket;
    });
    return total;
  }
  get day(): Date {
    return this.order?.start_date || this.stepOneFormGroup.value.day;
  }

  get quantity3or7(): number {
    return this.visitorForm.length;
  }

  get visitors() {
    return this.visitorForm.value;
  }

  get numDay(): number {
    return this.stepOneFormGroup.value.num_day;
  }

  get ticketType(): TicketType {
    return this.ticketTypes.find(type => type.num_day == this.numDay)
  }

  get totalPrice(): number {
    return this.order ? this.order.total_price : null
  }

  get ticketOrder(): any {
    return this.order ? this.order?.tickets : []
  }

  get price(): number {
    const formValue = this.stepOneFormGroup.value;
    const ticket = this.ticketTypes.find(ticket => ticket.num_day == formValue.num_day);
    if (!ticket) return;
    return ticket.price;
  }

  get currentLang(): string {
    return this.utility.getLang();
  }

  get isPickup(): boolean {
    return this.stepOneFormGroup.value.is_pickup
  }

  getExpiryDate(entryDate: any): string {
    const formData = this.stepOneFormGroup.value;
    let numDay = this.isOneDayPass ? 1 : formData.num_day;
    let expiryDate = '';
    if (entryDate) {
      let entryMoment = moment(entryDate);
      switch (numDay) {
        case 3:
          expiryDate = entryMoment.add(9, 'days').format('YYYY-MM-DD');
          break;

        case 7:
          expiryDate = entryMoment.add(29, 'days').format('YYYY-MM-DD');
          break;

        default:
          expiryDate = entryMoment.format('YYYY-MM-DD');
          break;
      }
    }
    return expiryDate;
  }


  getNationalityByID(id: string): string {
    if (!id || !this.countries) return '';

    const nationality = this.countries.find(c => c._id === id);
    return nationality?.name?.[this.currentLang]
      || nationality?.name?.[this.defaultLang]
      || '';
  }

  // getNationalityByID(id: string): Nationality {
  //   return this.countries?.find(country => country._id == id) || {} as Nationality;
  // }

  getGroupAgeByID(id: string): GroupAge {
    return this.groupsAge?.find(age => age._id == id) || {} as GroupAge;
  }

  oneDayValidator(): void {
    this.ticketForm.markAllAsTouched();
    if (this.stepOneFormGroup.invalid) {
      this.openMessageSnackbar('MSG.DATE_INVALID', 3000);
      this.stepper.selectedIndex = STEP.TICKET_SELECTION;
    }
    if (this.ticketForm.invalid) {
      this.openMessageSnackbar('MSG.DATA_TICKET_INVALID', 3000);
      this.stepper.selectedIndex = STEP.NUMBER_OF_TICKET;
    }
  }

  async stepOneValidatorMessage(): Promise<void> {
    this.stepOneFormGroup.markAllAsTouched();
    if (!this.ticketForm.length) {
      this.openMessageSnackbar('MSG.DATE_INVALID', 3000);
    } else
      if (this.stepOneFormGroup.controls['is_pickup'].invalid) {
        this.openMessageSnackbar('MSG.IS_PICK_UP_INVALID', 3000);
      }
  }

  visitorsValidator(): void {
    this.visitorForm.markAllAsTouched();
    if (this.visitorForm.invalid) {
      // this.openMessageSnackbar('MSG.DATA_TICKET_INVALID', 3000);
      this.stepper.selectedIndex = STEP.VISITOR_INFORMATION;
    }
  }

  stepOneAndTwoValidatorMessage(): void {
    this.stepOneFormGroup.markAllAsTouched();
    if (!this.ticketForm.length) {
      this.openMessageSnackbar('MSG.DATE_INVALID', 3000);
      this.stepper.selectedIndex = STEP.VISITOR_INFORMATION
    } else if (this.stepOneFormGroup.controls['is_pickup'].invalid) {
      this.openMessageSnackbar('MSG.IS_PICK_UP_INVALID', 3000);
    } else if (this.ticketForm.valid) {
      this.hasTicket.setValue(true);
      this.stepper.selectedIndex = STEP.VISITOR_INFORMATION
    }
  }

  stepThreeValidatorMessage(): void {
    this.visitorForm.markAllAsTouched();
    if (!this.ticketForm.length) {
      this.openMessageSnackbar('MSG.DATE_INVALID', 3000);
    }
    else if (this.visitorForm.invalid) {
      this.openMessageSnackbar('MSG.DATA_VISITOR_INVALID', 3000);
      this.stepper.selectedIndex = STEP.VISITOR_INFORMATION;
    }
    else if (this.visitorForm.controls[0].invalid) {
      this.openMessageSnackbar('MSG.VISITOR_INVALID', 3000);
      this.stepper.selectedIndex = STEP.VISITOR_INFORMATION;
    }
  }
  onAgree() {
    this.dialog.open(TermsDialogComponent, {
      width: '1000px',
      disableClose: true,
      autoFocus: false,
      data: {
        type: 'payment'
      }
    })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.isAgree.setValue(true);
          this.loadingService.setLoading(false);
        }
      })
  }

  get self(): UserModel {
    return this.user.me || {} as UserModel;
  }

  ngOnDestroy(): void {
    this.formChanged = false;
    this.visitorForm.reset({}, { emitEvent: false });
    this.stepOneFormGroup.reset({}, { emitEvent: false });
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.localStorage.delete(LocalStorage.ticket_type_param);
    this.localStorage.delete(LocalStorage.payment_data);
    this.localStorage.delete(LocalStorage.his_status);

    this.clearTransactionInterval();
    this._destroyed.next();
    this._destroyed.complete();
  }

  setDateFormat(date: any) {
    return this.utility.setDate_dd_MMM_YYYY(date)
  }

  setDateToday_DD_MMM_YYYY(date: Date): string | null {
    return this.utility.setDateToday_DD_MMM_YYYY(date);
  }

  setLiveDateFormat(date: any) {
    return this.utility.setDate_dddd_MMMM_DD_YYYY_hh_mm_ss_A(date);
  }

  setDate_UTC_Cambodia(date: any) {
    return this.utility.set_UTC_Cambodia(date);
  }

  setDate_Ticket(date: any) {
    return this.utility.setDate_Ticket(date);
  }

  getMonth(date: any) {
    return this.utility.setDate_dd_MMM_YYYY(date);
  }
}
